'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
const useSelect = (cssVariables, role, disabled, optionSelected, t0) => {
  const $ = _c(37);
  const border = t0 === undefined ? false : t0;
  const [bodyElement, setBodyElement] = useState(null);
  let t1;
  if ($[0] !== disabled || $[1] !== optionSelected) {
    t1 = option => {
      if (disabled) {
        return;
      }
      optionSelected(option === null || option === void 0 ? void 0 : option.value);
    };
    $[0] = disabled;
    $[1] = optionSelected;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onChange = t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setBodyElement(document.body);
    };
    t3 = [];
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== cssVariables || $[6] !== role) {
    t4 = base => {
      const roles = {
        card: {
          backgroundColor: cssVariables.cardBackgroundColor[0],
          "&:active": cssVariables.cardBackgroundColor[0],
          border: 0,
          color: cssVariables.cardSubtitleColor[0]
        },
        input: {
          backgroundColor: cssVariables.inputBackgroundColor[0],
          "&:active": cssVariables.inputBackgroundColor[0],
          border: 0,
          color: cssVariables.inputSelectionTextColor[0]
        }
      };
      return Object.assign(Object.assign({}, base), roles[role]);
    };
    $[5] = cssVariables;
    $[6] = role;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== border || $[9] !== cssVariables || $[10] !== role) {
    t5 = base_0 => {
      const roles_0 = {
        card: {
          border: `${border ? 1 : 0}px solid ${cssVariables.cardBorderColor[0]}`,
          backgroundColor: cssVariables.cardBackgroundColor[0],
          boxShadow: "none",
          "&:hover": {
            border: `1px solid ${cssVariables.cardBorderColor[0]}`
          },
          color: cssVariables.cardSubtitleColor[0]
        },
        input: {
          border: `${border ? 1 : 0}px solid ${cssVariables.inputBorderColor[0]}`,
          backgroundColor: cssVariables.inputBackgroundColor[0],
          boxShadow: "none",
          "&:hover": {
            border: `1px solid ${cssVariables.inputBorderColor[0]}`
          },
          color: cssVariables.inputSelectionTextColor[0]
        }
      };
      return Object.assign(Object.assign({}, base_0), roles_0[role]);
    };
    $[8] = border;
    $[9] = cssVariables;
    $[10] = role;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t10;
  let t11;
  let t12;
  let t13;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[12] !== cssVariables || $[13] !== role) {
    t6 = base_1 => {
      const roles_1 = {
        card: {
          backgroundColor: cssVariables.cardBackgroundColor[0]
        },
        input: {
          backgroundColor: cssVariables.inputBackgroundColor[0]
        }
      };
      return Object.assign(Object.assign(Object.assign({}, base_1), roles_1[role]), {
        zIndex: 9999
      });
    };
    t7 = base_2 => {
      const roles_2 = {
        card: {
          "::-webkit-scrollbar": {
            backgroundColor: cssVariables.cardBackgroundColor[0]
          },
          "::-webkit-scrollbar-track": {
            backgroundColor: cssVariables.cardBackgroundColor[0]
          },
          "::-webkit-scrollbar-thumb": {
            backgroundColor: cssVariables.cardBorderColor[0]
          },
          "::-webkit-scrollbar-thumb:hover": {
            backgroundColor: cssVariables.cardBorderColor[0]
          }
        },
        input: {}
      };
      return Object.assign(Object.assign(Object.assign({}, base_2), roles_2[role]), {
        borderRadius: "0.25rem"
      });
    };
    t8 = base_3 => {
      const roles_3 = {
        card: {
          color: cssVariables.cardSubtitleColor[0]
        },
        input: {
          color: cssVariables.inputSelectionTextColor[0]
        }
      };
      return Object.assign(Object.assign({}, base_3), roles_3[role]);
    };
    t9 = base_4 => {
      const roles_4 = {
        card: {
          color: cssVariables.cardSubtitleColor[0]
        },
        input: {
          color: cssVariables.inputPlaceholderTextColor[0]
        }
      };
      return Object.assign(Object.assign({}, base_4), roles_4[role]);
    };
    t10 = base_5 => {
      const roles_5 = {
        card: {
          backgroundColor: cssVariables.cardBorderColor[0]
        },
        input: {
          backgroundColor: cssVariables.inputBorderColor[0]
        }
      };
      return Object.assign(Object.assign({}, base_5), roles_5[role]);
    };
    t11 = base_6 => {
      const roles_6 = {
        card: {
          color: cssVariables.cardSubtitleColor[0]
        },
        input: {
          color: cssVariables.inputPlaceholderTextColor[0]
        }
      };
      return Object.assign(Object.assign({}, base_6), roles_6[role]);
    };
    t12 = base_7 => {
      const roles_7 = {
        card: {
          color: cssVariables.cardSubtitleColor[0]
        },
        input: {
          color: cssVariables.inputSelectionTextColor[0]
        }
      };
      return Object.assign(Object.assign({}, base_7), roles_7[role]);
    };
    t13 = base_8 => {
      const roles_8 = {
        card: {
          color: cssVariables.cardSubtitleColor[0]
        },
        input: {
          color: cssVariables.inputSelectionTextColor[0]
        }
      };
      return Object.assign(Object.assign({}, base_8), roles_8[role]);
    };
    $[12] = cssVariables;
    $[13] = role;
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
    $[17] = t13;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t10 = $[14];
    t11 = $[15];
    t12 = $[16];
    t13 = $[17];
    t6 = $[18];
    t7 = $[19];
    t8 = $[20];
    t9 = $[21];
  }
  let t14;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== t12 || $[25] !== t13 || $[26] !== t4 || $[27] !== t5 || $[28] !== t6 || $[29] !== t7 || $[30] !== t8 || $[31] !== t9) {
    t14 = {
      option: t4,
      control: t5,
      menu: t6,
      menuList: t7,
      input: t8,
      clearIndicator: t9,
      indicatorSeparator: t10,
      placeholder: t11,
      singleValue: t12,
      dropdownIndicator: t13,
      menuPortal: _temp
    };
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  const styles = t14;
  let t15;
  if ($[33] !== bodyElement || $[34] !== onChange || $[35] !== styles) {
    t15 = {
      styles,
      onChange,
      bodyElement
    };
    $[33] = bodyElement;
    $[34] = onChange;
    $[35] = styles;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  return t15;
};
export default useSelect;
function _temp(base_9) {
  return Object.assign(Object.assign({}, base_9), {
    zIndex: 9999
  });
}